<template>
  <div class="email-box button-switch" style="align-item: center">
    <transition name="appear">
      <div v-show="isOpen" :id="`collapse${_uid}`">
        <img src="https://storage.googleapis.com/cleed-datacenter-europe/whatsapp/qr.png" style="width: 80%; display: block; text-align: center; margin: auto;" />
      </div>
    </transition>
    <div v-if="!isMobile" style="display: block; text-align: center;">
      <button
        :aria-expanded="isOpen"
        :aria-controls="`collapse${_uid}`"
        @click="toggleAccordion()"
      >
        <span style="margin-left: 10px; margin-right: 20px"> {{ $t("whatsapp_messaging.switch") }}</span>
        <svg
          :class="isOpen ? 'rotate-180' : ''"
          fill="none"
          stroke="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 10"
          aria-hidden="true"
          style="width: 15px"
        >
          <path
            d="M15 1.2l-7 7-7-7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <div style="width: 100%; padding-top: 5px; padding-bottom: 10px; font-size: 15px;"> 
        <span>  {{ $t("whatsapp_messaging.or") }} </span>
      </div>

      <div style="width: 100%">
        <a
          href="https://api.whatsapp.com/send/?phone=33780949086&text&type=phone_number&app_absent=0"
          target="_BLANK"
        >
          <button>
            <span style="margin-left: 10px; margin-right: 20px"> {{ $t("whatsapp_messaging.click_here") }}</span>
          </button>
        </a>
      </div>
    </div>
    <div v-else>
      <a
        href="https://api.whatsapp.com/send/?phone=33780949086&text&type=phone_number&app_absent=0"
        target="_BLANK"
      >
        <button>
          <span style="margin-left: 10px; margin-right: 20px"> {{ $t("whatsapp_messaging.switch") }}</span>
        </button>
      </a>
    </div>
  </div>
</template>
  
  <script>
import utils from "../utils";

export default {
  name: "Accordion",
  data() {
    return {
      isMobile: utils.isMobile(),
      isOpen: false,
    };
  },
  mounted() {setTimeout(() => { utils.scrollDown(); }, 150)},
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
      setTimeout(() => { utils.scrollDown(); }, 100);
    },
  },
};
</script>
